"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Practice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdatePackageInstanceDetailsRequestToJSON = exports.UpdatePackageInstanceDetailsRequestFromJSONTyped = exports.UpdatePackageInstanceDetailsRequestFromJSON = exports.instanceOfUpdatePackageInstanceDetailsRequest = void 0;
const runtime_1 = require("../runtime");
const OnTrackNotifications_1 = require("./OnTrackNotifications");
const OnTrackRules_1 = require("./OnTrackRules");
const OnTrackStatus_1 = require("./OnTrackStatus");
const PackageInstanceOrganizationSettings_1 = require("./PackageInstanceOrganizationSettings");
const UpdatePackageInstanceDetailsRequestBillingRatesInner_1 = require("./UpdatePackageInstanceDetailsRequestBillingRatesInner");
const UpdatePackageInstanceDetailsRequestCurriculumAssignmentsInner_1 = require("./UpdatePackageInstanceDetailsRequestCurriculumAssignmentsInner");
const UpdatePackageInstanceDetailsRequestMembersInner_1 = require("./UpdatePackageInstanceDetailsRequestMembersInner");
/**
 * Check if a given object implements the UpdatePackageInstanceDetailsRequest interface.
 */
function instanceOfUpdatePackageInstanceDetailsRequest(value) {
    let isInstance = true;
    return isInstance;
}
exports.instanceOfUpdatePackageInstanceDetailsRequest = instanceOfUpdatePackageInstanceDetailsRequest;
function UpdatePackageInstanceDetailsRequestFromJSON(json) {
    return UpdatePackageInstanceDetailsRequestFromJSONTyped(json, false);
}
exports.UpdatePackageInstanceDetailsRequestFromJSON = UpdatePackageInstanceDetailsRequestFromJSON;
function UpdatePackageInstanceDetailsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'clientId': !(0, runtime_1.exists)(json, 'clientId') ? undefined : json['clientId'],
        'title': !(0, runtime_1.exists)(json, 'title') ? undefined : json['title'],
        'icon': !(0, runtime_1.exists)(json, 'icon') ? undefined : json['icon'],
        'locked': !(0, runtime_1.exists)(json, 'locked') ? undefined : json['locked'],
        'participants': !(0, runtime_1.exists)(json, 'participants') ? undefined : json['participants'],
        'supervisors': !(0, runtime_1.exists)(json, 'supervisors') ? undefined : json['supervisors'],
        'organizationSettings': !(0, runtime_1.exists)(json, 'organizationSettings') ? undefined : (0, PackageInstanceOrganizationSettings_1.PackageInstanceOrganizationSettingsFromJSON)(json['organizationSettings']),
        'billingRates': !(0, runtime_1.exists)(json, 'billingRates') ? undefined : (json['billingRates'].map(UpdatePackageInstanceDetailsRequestBillingRatesInner_1.UpdatePackageInstanceDetailsRequestBillingRatesInnerFromJSON)),
        'members': !(0, runtime_1.exists)(json, 'members') ? undefined : (json['members'].map(UpdatePackageInstanceDetailsRequestMembersInner_1.UpdatePackageInstanceDetailsRequestMembersInnerFromJSON)),
        'curriculumAssignments': !(0, runtime_1.exists)(json, 'curriculumAssignments') ? undefined : (json['curriculumAssignments'].map(UpdatePackageInstanceDetailsRequestCurriculumAssignmentsInner_1.UpdatePackageInstanceDetailsRequestCurriculumAssignmentsInnerFromJSON)),
        'onTrackRules': !(0, runtime_1.exists)(json, 'onTrackRules') ? undefined : (0, OnTrackRules_1.OnTrackRulesFromJSON)(json['onTrackRules']),
        'onTrackNotifications': !(0, runtime_1.exists)(json, 'onTrackNotifications') ? undefined : (0, OnTrackNotifications_1.OnTrackNotificationsFromJSON)(json['onTrackNotifications']),
        'onTrackEnabled': !(0, runtime_1.exists)(json, 'onTrackEnabled') ? undefined : json['onTrackEnabled'],
        'onTrackStatus': !(0, runtime_1.exists)(json, 'onTrackStatus') ? undefined : (0, OnTrackStatus_1.OnTrackStatusFromJSON)(json['onTrackStatus']),
    };
}
exports.UpdatePackageInstanceDetailsRequestFromJSONTyped = UpdatePackageInstanceDetailsRequestFromJSONTyped;
function UpdatePackageInstanceDetailsRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'clientId': value.clientId,
        'title': value.title,
        'icon': value.icon,
        'locked': value.locked,
        'participants': value.participants,
        'supervisors': value.supervisors,
        'organizationSettings': (0, PackageInstanceOrganizationSettings_1.PackageInstanceOrganizationSettingsToJSON)(value.organizationSettings),
        'billingRates': value.billingRates === undefined ? undefined : (value.billingRates.map(UpdatePackageInstanceDetailsRequestBillingRatesInner_1.UpdatePackageInstanceDetailsRequestBillingRatesInnerToJSON)),
        'members': value.members === undefined ? undefined : (value.members.map(UpdatePackageInstanceDetailsRequestMembersInner_1.UpdatePackageInstanceDetailsRequestMembersInnerToJSON)),
        'curriculumAssignments': value.curriculumAssignments === undefined ? undefined : (value.curriculumAssignments.map(UpdatePackageInstanceDetailsRequestCurriculumAssignmentsInner_1.UpdatePackageInstanceDetailsRequestCurriculumAssignmentsInnerToJSON)),
        'onTrackRules': (0, OnTrackRules_1.OnTrackRulesToJSON)(value.onTrackRules),
        'onTrackNotifications': (0, OnTrackNotifications_1.OnTrackNotificationsToJSON)(value.onTrackNotifications),
        'onTrackEnabled': value.onTrackEnabled,
        'onTrackStatus': (0, OnTrackStatus_1.OnTrackStatusToJSON)(value.onTrackStatus),
    };
}
exports.UpdatePackageInstanceDetailsRequestToJSON = UpdatePackageInstanceDetailsRequestToJSON;
//# sourceMappingURL=UpdatePackageInstanceDetailsRequest.js.map